<template>
  <div>
    <el-button @click="openExportWorkflowData" type="primary" size="medium" v-if="!fromApprovalFormView">
      <span class="export-text">
        Export
        <i class="el-icon-upload2"></i>
      </span>
    </el-button>

    <dialog-component
      :title="'Export ' + formbuilderDetails.name + `'s data`"
      :visible="exportTemplatesDataDialogVisible"
      @before-close="CloseExportWorkflowData"
      width="50%"
      :containerWidth="'50%'"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div
        v-loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-input placeholder="Search Field" v-model="filterText"></el-input>
        <el-tree
          class="filter-tree"
          :data="
            templatesFields?.length ? templatesFields : allFormbuilderFields
          "
          :props="defaultProps"
          default-expand-all
          show-checkbox
          highlight-current
          :filter-node-method="filterNode"
          ref="tree"
          node-key="key"
          :default-checked-keys="checkedFields"
        ></el-tree>
      </div>
      <span slot="footer">
        <el-button @click="handleClose">Cancel</el-button>
        <el-button type="success" @click="submitData">
          <i class="fa fa-cloud-upload"></i> Export
        </el-button>
      </span>
    </dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { groupBy } from "../../helpers/appHelper";
export default {
  props: [
    "formbuilderDetails",
    "templatesFields",
    "selectedFields",
    "applicationUserFilledDataIds",
    "fromApprovalFormView",
  ],
  components: {},
  data() {
    return {
      loadingText: "Loading, please wait...",
      templateIds: [],
      contentFields: [
        "HEADING",
        "PARAGRAPH",
        "VIDEO",
        "SINGLE_LINE_CONTENT",
        "HORIZONTAL_LINE",
        "DIVISION",
        "HTML_CONTENT",
        "ACTION_BUTTON",
        "HTML_CONTENT",
      ],
      allFormbuilderFields: [],
      exportTemplatesDataDialogVisible: false,
      newEntityForm: {},
      sections: [],
      loading: false,
      laodingText: "",
      defaultProps: {
        children: "fields",
        id: "template_id",
        label: "label",
        table_display: "table_display",
      },
      filterText: "",
      checkedFields: [],
    };
  },
  computed: {
    ...mapGetters("formbuilderData", [
      "getUsersFormbuilderTemplatesDataExportStatus",
    ]),
    localFormbuilderDetails() {
      return JSON.parse(JSON.stringify(this.formbuilderDetails))
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  mounted() {
    // we have to group the primary fields
    if (this.selectedFields && this.selectedFields.length) {
      this.checkedFields = this.selectedFields;
    }
    if (this.fromApprovalFormView) {
      this.openExportWorkflowData();
    }
  },

  methods: {
    async getAllFormbuilderFields() {
      let entities = this.localFormbuilderDetails.steps.filter(
        (step) => step.type == "ENTITY"
      );
      let templates = this.localFormbuilderDetails.steps
        .filter(
          (step) => step.type == "TEMPLATE" && !step?.settings?.is_repeatable
        )
        .map((step) => step.template);
      entities.forEach((entity) => {
        let allowedTemplates = entity?.settings?.selectedTemplates
          ? entity.settings.selectedTemplates
          : [];
        if (entity?.entity?.templates) {
          entity.entity.templates.forEach((template) => {
            let tempId = template?.template_id?._id || template?.template_id;
            if (
              (template?.template_id?._id || template?.templateInfo) &&
              allowedTemplates.indexOf(tempId) != -1
            ) {
              let fields = this.getTemplateFields(
                template.templateInfo || template.template_id,
                "ENTITY",
                entity.entity
              );
              this.allFormbuilderFields.push({
                fields: fields,
                label: entity.entity.name + "-" + (template?.template_id?.name || template?.templateInfo?.name),
                key: template._id,
                entity_id: entity._id,
              });
            }
          });
        }
      });
      this.templateIds = templates.map((template) => template._id);
      this.allFormbuilderFields = [
        ...this.allFormbuilderFields,
        ...templates.map((template) => {
          template.fields = this.getTemplateFields(template, "TEMPLATE");
          template.label = template.name;
          template.key = template._id;
          return template;
        }),
      ];
      this.allFormbuilderFields = this.allFormbuilderFields.map((template) => ({
        ...template,
        fields: template.fields.filter(
          (field) => this.contentFields.indexOf(field.input_type) === -1
        ),
      }));
    },
    getTemplateFields(data, type, entity = {}) {
      let fields = [];
      data.sections.forEach((e) => {
        fields = [...fields, ...e.fields];
      });
      fields = fields.map((e) => {
        e.template_id = data._id;
        e.template_title = data.name;
        e.checked = true;
        e.table_display = true;
        e.type = type;
        if (type == "ENTITY" && entity?._id) {
          e.label = entity.name + " - " + data.name + " - " + e.label;
          e.data_key = entity._id + "#" + data._id + "#" + e.key;
          e.key = entity._id + "#" + data._id + "#" + e.key;
          e.entity_type_id = entity._id;
        } else {
          e.data_key = data._id + "#" + e.key;
          e.key = data._id + "#" + e.key;
          e.label = data.name + " - " + e.label;
        }
        return e;
      });
      return fields;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    handleClose() {
      this.filterText = "";
      this.exportTemplatesDataDialogVisible = false;
    },
    async openExportWorkflowData() {
      this.exportTemplatesDataDialogVisible = true;
      this.loading = true;
      if (!this.templatesFields?.length) {
        await this.getAllFormbuilderFields();
      }
      this.templates = groupBy(this.templatesFields, "template_id", true);
      this.loading = false;
    },
    CloseExportWorkflowData() {
      this.exportTemplatesDataDialogVisible = false;
    },
    async submitData() {
      try {
        this.loading = true;
        this.loadingText ="Downloading Excel, please wait..."

        this.exportTemplatesDataDialogVisible = true;

        let checked = this.$refs.tree.getCheckedNodes();
        checked = checked.filter((e) => !e.fields);

        checked = checked.map((f) => {
          return {
            label: f.label,
            template_name: f.template_title,
            template_id: f.template_id,
            entity_id: f.entity_type_id || null,
            key: f?.key?.split("#").pop(),
            input_type: f.input_type,
            data_table_columns: f.data_table_columns || [],
            validations: f.validations || {},
          };
        });

        let params = {
          formbuilder_id: this.formbuilderDetails._id,
          fields: checked,
          name: this.formbuilderDetails.name,
          timeZoneFormatOffset: this.getTimeZone(),
          data_ids: this.applicationUserFilledDataIds?.length
            ? this.applicationUserFilledDataIds
            : [],
        };
        await this.$store.dispatch(
          "formbuilderData/exportUsersFormbuilderTemplatesData",
          params
        );
        if (this.getUsersFormbuilderTemplatesDataExportStatus) {
          this.loading = false;
          this.exportTemplatesDataDialogVisible = false;
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error while downloading data",
          });
          this.loading = false;
          this.exportTemplatesDataDialogVisible = false;
        }
      } catch (err) {
        this.loading = false;
        console.log("submitData", err);
      }
    },
    getTimeZone() {
      let date1 = new Date();
      var sign = date1.getTimezoneOffset() > 0 ? "-" : "+";
      var offset = Math.abs(date1.getTimezoneOffset());
      var hours =
        Math.floor(offset / 60) < 10
          ? "0" + Math.floor(offset / 60)
          : Math.floor(offset / 60);
      var minutes = offset % 60 < 10 ? "0" + (offset % 60) : offset % 60;
      let timezoneoffset = sign + hours + ":" + minutes;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return timezone + ", UTC" + timezoneoffset;
    },
  },
};
</script>

<style lang="scss" scoped>
.DetailedView-Export {
  margin: 20px;
}
.el-button--primary {
  height: 32px !important;
}
.export-text {
  position: relative;
  bottom: 2px;
}
.el-button--success {
  color: var(--primary-contrast-color);
  background-color: var(--primary-color);
  border: var(--primary-color);
}
</style>
